import React, { useEffect, useState } from "react";
import {
  formatDate,
  formatPhoneNumber,
  formatTime,
  secondsToMinutes,
  formatType,
  backgroundColor,
} from "../../functions/util/format";
import { BsPlayFill, BsStopFill, BsCloudArrowDown } from "react-icons/bs";
import { MdArchive, MdUnarchive } from "react-icons/md";
import Sound from "react-sound";
import serverUrl from "../../constants/serverUrl";
import ArchiveCommModal from "../modals/ArchiveCommModal";
import fileDownload from "js-file-download";
import { updateVoicemail } from "../../functions/office/commRecords";

const Recording = ({ recording, users, reload }) => {
  //the react-sound pkg prints authToken to console without the debugMode turned off.
  //aka keep this line it is very important
  window.soundManager.setup({ debugMode: false });
  /////
  const [formattedDate, setFormattedDate] = useState("");
  const [formattedTo, setFormattedTo] = useState("");
  const [formattedType, setFormattedType] = useState("");
  const [formattedFrom, setFormattedFrom] = useState("");
  const [formattedTime, setFormattedTime] = useState("");
  const [formattedDuration, setFormattedDuration] = useState("");
  const [color, setColor] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [recordingLink, setRecordingLink] = useState("");
  const [archiveCommModal, setArchiveCommModal] = useState(false);
  const [tag, setTag] = useState(recording.tag);
  const [assignment, setAssignment] = useState(recording.assignedTo);

  useEffect(() => {
    setTag(recording.tag);
    setAssignment({ _id: recording.assignedTo });
  }, [recording.tag, recording.assignedTo]);

  useEffect(() => {
    const formatting = async () => {
      const color = await backgroundColor(recording.flag, recording.type);
      setColor(color);
      const date = await formatDate(recording.recordingStart);
      setFormattedDate(date);
      const fromNumber = await formatPhoneNumber(recording.from);
      setFormattedFrom(fromNumber);
      const toNumber = await formatPhoneNumber(recording.to);
      setFormattedTo(toNumber);
      const time = await formatTime(recording.recordingStart);
      setFormattedTime(time);
      const vmDuration = await secondsToMinutes(recording.recordingDuration);
      setFormattedDuration(vmDuration);
      const rawType = await formatType(recording.type);
      setFormattedType(rawType);
    };
    formatting();
  }, [recording.flagged, color]);

  const handlePlay = async (serverUrl) => {
    setIsPlaying(!isPlaying);
    const twilioUrl = await encodeURI(recording.recordingUrl);
    let authToken = await localStorage.getItem("authToken");
    // removes quotations from authToken string
    authToken = authToken.replace(/"/g, "");
    const recordingLink =
      serverUrl + "/recording?twilioUrl=" + twilioUrl + "&token=" + authToken;
    setRecordingLink(recordingLink);
  };

  const updateTag = async (newTag) => {
    updateVoicemail(recording._id, { tag: newTag });
    setTag(newTag);
  };

  const updateAssignment = async (assignedTo) => {
    updateVoicemail(recording._id, { assignedTo });
    setAssignment({ _id: assignedTo });
  };

  const handleDownload = async () => {
    const twilioUrl = await encodeURI(recording.recordingUrl);
    let authToken = await localStorage.getItem("authToken");
    // removes quotations from authToken string
    authToken = authToken.replace(/"/g, "");
    const recordingLink =
      serverUrl + "/recording?twilioUrl=" + twilioUrl + "&token=" + authToken;

    fetch(recordingLink)
      .then((response) => response.blob())
      .then((blobData) => {
        // Use fileDownload to save the blob data
        fileDownload(
          blobData,
          `${formattedDate} ${recording.from}  ${recording.to} recording.wav`,
        );
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  return (
    <>
      <tr style={{ backgroundColor: color }}>
        <td className="table-item">{formattedDate}</td>
        <td className="table-item">{formattedTime}</td>
        <td className="table-item">{formattedType}</td>
        <td className="table-item">{formattedFrom}</td>
        <td className="table-item">{formattedTo}</td>
        <td className="table-item">{formattedDuration}</td>
        <td className="table-icon-container">
          {isPlaying ? (
            <BsStopFill
              className="table-icon"
              color="#219ebc"
              size={35}
              onClick={() => setIsPlaying(false)}
            />
          ) : (
            <BsPlayFill
              className="table-icon"
              color="#219ebc"
              size={35}
              onClick={() => handlePlay(serverUrl)}
            />
          )}
          <Sound
            url={recordingLink}
            playStatus={isPlaying ? Sound.status.PLAYING : Sound.status.STOPPED}
            onFinishedPlaying={() => setIsPlaying(false)}
          />
          <BsCloudArrowDown
            className="table-icon"
            color="#000"
            size={25}
            onClick={handleDownload}
          />
        </td>
        <td className="table-icon-container">
          {recording.isArchived === true ? (
            <MdUnarchive
              className="table-icon"
              color="#adadad"
              size={35}
              onClick={() => setArchiveCommModal(true)}
              title="Unarchive"
            ></MdUnarchive>
          ) : (
            <MdArchive
              className="table-icon"
              color="#fb8500"
              size={35}
              onClick={() => setArchiveCommModal(true)}
              title="Archive"
            />
          )}
          {archiveCommModal && (
            <ArchiveCommModal
              setArchiveCommModal={setArchiveCommModal}
              isArchived={recording.isArchived}
              data={recording}
              reload={reload}
            />
          )}
        </td>
      </tr>
      {(recording.type === "voicemail" ||
        recording.type === "flagVoicemail") && (
        <tr className="border-b-8 border-white bg-gray-100">
          <td colSpan={8} className="px-6 py-4">
            <div className="flex flex-row gap-6 text-gray-200">
              {/* Status */}
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-900">
                  Status:
                </span>
                {recording.returned && (
                  <span className="rounded-full bg-green-600/80 px-3 py-1 text-sm font-semibold uppercase text-white shadow-sm">
                    Returned
                  </span>
                )}
                {!recording.returned && (
                  <span
                    className={
                      "rounded-full " +
                      (recording.readBy ? "bg-blue-600/80" : "bg-red-600/80") +
                      " px-3 py-1 text-sm font-semibold uppercase text-white shadow-sm"
                    }
                  >
                    {recording.readBy ? "Read" : "Unread"}
                  </span>
                )}
              </div>

              {/* Tag */}
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-900">Tag:</span>
                <select
                  className="rounded-lg border border-gray-600 bg-gray-300 px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500/30"
                  value={tag || ""}
                  onChange={(e) => updateTag(e.target.value)}
                >
                  <option value="">Select Tag</option>
                  <option value="wrong-number">Wrong Number</option>
                  <option value="spam">Spam</option>
                  <option value="robocall">RoboCall</option>
                  <option value="personal">Personal</option>
                  <option value="silent">Silent</option>
                  <option value="duplicate">Duplicate</option>
                  <option value="out-of-scope">Out-of-Scope</option>
                  <option value="needs-review">Needs Review</option>
                  <option value="pending">Pending</option>
                  <option value="call-back">Call Back</option>
                  <option value="resolved">Resolved</option>
                </select>
              </div>

              {/* Read By */}
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-900">
                  Read By:
                </span>
                <span className="rounded-md bg-gray-200 px-3 py-1 text-sm font-semibold text-black">
                  {(() => {
                    const readByUser =
                      users && users.find((u) => u._id === recording.readBy);
                    return readByUser
                      ? `${readByUser.firstName} ${readByUser.lastName}`
                      : "N/A";
                  })()}
                </span>
              </div>

              {/* Assigned To */}
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-900">
                  Assigned To:
                </span>
                <select
                  className="rounded-lg border border-gray-600 bg-gray-300 px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500/30"
                  value={assignment ? assignment._id : ""}
                  onChange={(e) => updateAssignment(e.target.value)}
                >
                  <option value="">Select Assignment</option>
                  {users &&
                    users.map((u) => (
                      <option key={u._id} value={u._id}>
                        {`${u.firstName} ${u.lastName}`}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

export default Recording;
